import { JobsListingPage } from 'src/modules/jobs';
import { fetchCareersPageData } from 'src/modules/pages';
import { fetchJobsListingData } from 'src/modules/jobs/listing/store/actions';

export const getStaticProps = async () => {
  const data = await fetchCareersPageData();
  const jobsListingData = await fetchJobsListingData();
  const jobs = jobsListingData?.jobs || [];

  return { props: { careersPage: { ...data, jobs } } };
};

export default JobsListingPage;
